module.exports = __webpack_public_path__ + "media/images/Octopus-feade5da.jpg";